import { Err, Ok } from "../common/result";

/**
 * @param {string} sheetName
 */
export function getReportsSheetNameFromSheetName(sheetName) {
  // TODO: Fragile string replacement code, need to find a better way to handle this
  return sheetName.replace("Map", "Reports");
}

/**
 * @param {string} sheetName
 */
export function getReportsTableNameFromSheetName(sheetName) {
  // TODO: Fragile string replacement code, need to find a better way to handle this
  return sheetName.replace(" ", "_").replace("Map", "Reports");
}

/**
 * @param {string} tableName
 */
export function getSheetNameFromMappingTableName(tableName) {
  // TODO: Fragile string replacement code, need to find a better way to
  // source the table name or maybe we make it match the sheet name?
  return tableName.replace("_", " ");
}

/**
 * @param {string} sheetName
 */
export function getMappingTableNameFromSheetName(sheetName) {
  // TODO: Fragile string replacement code, need to find a better way to
  // source the table name or maybe we make it match the sheet name?
  return sheetName.replace(" ", "_");
}

/**
 * @param {Excel.RequestContext} context
 * @param {Excel.TableChangedEventArgs} event
 *
 * @returns {Promise<import("../common/result").Result<{
    sheetName: string,
    tableName: string,
    columnName: string,
    changedRange: Excel.Range
   }, string>>}
 */
export async function getPathOfEventInteraction(context, event) {
  // Batch load operations
  let worksheet = context.workbook.worksheets.getItem(event.worksheetId);
  let changedRange = worksheet.getRange(event.address);
  const tableId = event.tableId;
  const table = worksheet.tables.getItem(tableId);
  const range = event.getRange(context);

  // Load all properties in a batch
  changedRange.load("rowIndex");
  worksheet.load("tables, name");
  table.load("columns, name");
  range.load("columnIndex,columnCount");

  await context.sync();

  // TODO: Figure out why the column index is off by 2!!!
  const column = table.columns.getItemAt(range.columnIndex - 2);
  column.load("name");
  await context.sync();

  const sheetName = worksheet.name;
  const tableName = table.name;
  const columnName = column.name;

  if (!sheetName) return Err(`Could not find worksheet name`);
  if (!tableName) return Err(`Could not find table name`);
  if (!columnName) return Err(`Could not find column name`);

  return Ok({
    sheetName,
    tableName,
    columnName,
    changedRange,
  });
}

/**
 * @param {unknown} error
 * @param {string} message
 */
export function logAndRethrow(error, message) {
  console.error(message);
  throw error;
}
